import { patientActions, userActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
    loading: false,
    loadingFotoEpisodes: true,
    selectedPtno: undefined
};

export const reducer = createReducer(initialState, {
    [patientActions.openSuccess]: (state, action) => {
        state.loading = false;
    },
    [userActions.loadSessionSuccess]: (state, action) => {
        if (action.payload.ui.patients) {
            state.selectedPtno = action.payload.ui.patients.selectedPtno;
        }
    },
    [patientActions.loadRequest]: (state, action) => {
        state.loading = true;
        state.selectedPtno = action.payload;
    },
    [patientActions.loadSuccess]: (state, action) => {
        state.loading = false;
    },
    [patientActions.loadFailure]: (state, action) => {
        state.loading = false;
    },
    [patientActions.setActive]: (state, action) => {
        state.selectedPtno = action.payload;
    },
    [patientActions.loadFotoEpisodesRequest]: (state, action) => {
        state.loadingFotoEpisodes = true;
    },
    [patientActions.loadFotoEpisodesSuccess]: (state, action) => {
        state.loadingFotoEpisodes = false;
    },
    [patientActions.refreshFotoEpisodesSuccess]: (state, action) => {
        state.loadingFotoEpisodes = false;
    },
    [patientActions.loadFotoEpisodesFailure]: (state, action) => {
        state.loadingFotoEpisodes = false;
    },
    [patientActions.refreshFotoResponseSuccess]: (state, action) => {
        state.loadingFotoEpisodes = false;
    },



})


